(function($, App, Utils, Components) {
  'use strict';

  const logger = new Logger('Filters');

  Components.create('Filters', {

    Selectors: {
      form: '[data-filters-type="form"]',
      action: '[data-filters-type="action"]',
      filtersCount: '.js-filters-count',
      clearableFilters: '.clearable input[type="checkbox"]',
      filter: 'input[type="checkbox"]'
    },

    Events: {
      filtersChange: 'filters:changes'
    },

    clear: (el, e) => {
      e.preventDefault();
      let checkbox = el.closest(Components.Filters.Selectors.form).find(Components.Filters.Selectors.clearableFilters);
      // logger.info(checkbox);
      $.each(checkbox, function() {
        let _this = $(this);
        _this.prop('checked', false);
      });
    },

    apply: (el, e) => {
      return true;
    },

    setFiltersCounter: () => {
      let checkedFilters = $(Components.Filters.Selectors.form).find(`${Components.Filters.Selectors.filter}:checked`);
      let filtersCountWrapper = $(Components.Filters.Selectors.filtersCount);
      filtersCountWrapper.empty().text(` (${checkedFilters.length})`);
    },


    bindEvents: () => {

      $(Components.Filters.Selectors.filter).on('change.flt', function (e) {
        Components.Filters.setFiltersCounter();
      });

      $(Components.Filters.Selectors.action).on('click.flt', function (e) {
        let actionType = $(this).data('filtersAction');

        if (actionType === 'clear') {
          e.preventDefault();
        }

        Components.Filters[$(this).data('filtersAction')]($(this), e);

        Components.Filters.setFiltersCounter();

      });

    },

    init: () => {
      Components.Filters.bindEvents();
      Components.Filters.setFiltersCounter();
    }

  });

})(jQuery,
    window.App,
    window.App.Utils,
    window.App.Components
);